import React, { useState, useRef, useEffect } from 'react';
import {
  Image,
  Popover,
  Overlay,
} from 'react-bootstrap';
import moment from 'moment';
import { connect, useDispatch } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';

import CustomRichTextViewer from 'components/base/CustomRichTextViewer'
import Loading from 'components/base/Loading'
import { formatDate, TimeFormater } from 'utils/TimeFormatUtil';

import askAI from 'assets/images/ask_ai.svg';
import aiNewChat from 'assets/images/ai_new_chat.svg'
import aiHistory from 'assets/images/ai_history.svg'
import closeIcon from 'assets/images/close.svg';
import "./AskAI.scss"

const chatQuestions = [
  {
    "id": 1,
    "question": "Recommend segment and campaign",
    "value": ""
  },
]

const mapPropsToState = (state) => ({
  answer: state.llm.answer,
  error: state.llm.error,
});

const AskAI = ({
  answer,
  error,
}) => {
  const dispatch = useDispatch();
  const popRef = useRef();
  const [showAIChat, setShowAIChat] = useState(false)
  const [isNewChat, setIsInNewChat] = useState(true)
  const [inChatting, setInChatting] = useState(false)
  const [inChattingHistory, setInChattingHistory] = useState(false)
  const [currentQuestion, setCurrentQuestion] = useState(null)
  const [inProcessingQuestion, setInProcessingQuestion] = useState(false)

  const resetAnswer = () => {
    dispatch({ type: "llm/updateState", payload: { answer: "" } })
  }

  const closeAskAIPop = () => {
    setShowAIChat(false)
    setIsInNewChat(false)
    setInChattingHistory(false)
    setCurrentQuestion(null)
    setInChatting(false)
    resetAnswer()
  }

  const showQuestionHistory = () => {

  }

  const startNewChat = () => {
    setIsInNewChat(true)
    setInChattingHistory(false)
    setCurrentQuestion(null)
    setInChatting(false)
    resetAnswer()
  }

  const startAskQuestion = (item) => {
    const now = moment()
    const time = formatDate(now, TimeFormater.dayMonthYearWeekTimeA)
    setIsInNewChat(false)
    setInChattingHistory(false)
    setCurrentQuestion({ ...item, time })
    setInChatting(true)
    resetAnswer()
  }

  useEffect(() => {
    if (!currentQuestion?.question) {
      return
    }
    dispatch({
      type: 'llm/startQuestion',
      payload: {
        question: currentQuestion?.question,
      },
    });
    return () => {
      dispatch({
        type: 'llm/abort'
      });
    }
  }, [currentQuestion])

  // useEffect(() => {
  //   if (!currentQuestion) {
  //     return
  //   }
  //   return
  //   const accessToken = Cookies.get("ACCESS_TOKEN");
  //   const question = `give me a conclusion of these information at ${moment().toISOString()}`;
  //   const encodeUri = encodeURIComponent(question);
  //   const encodeToken = encodeURIComponent(accessToken);
  //   const domain = "http://localhost:3001"
  //   const url = `${domain}/llm/ask-question?question=${encodeUri}&token=${encodeToken}`
  //   const source = new EventSource(url);
  //   source.onmessage = (event) => {
  //     try {
  //       console.log("event.data:", event.data)
  //       const data = JSON.parse(event.data);

  //       const messageEvent = event.event
  //       if (messageEvent == "workflow_finished") {
  //         console.log("workflow_finished close source");
  //         source.close()
  //       }
  //       setAnswer((prev) => prev + (data.answer || ""));
  //     } catch (err) {
  //       console.warn("Error parsing message:", err);
  //     }
  //   };

  //   source.onerror = (error) => {
  //     console.error("EventSource error close source:", error);
  //     source.close();
  //   };
  //   return () => {
  //     console.log("clean close source");
  //     source.close()
  //   }
  // }, [currentQuestion])

  const inChattingBody = () => {
    if(answer) {
      return <CustomRichTextViewer initialValue={answer} />
    }
    if(error) {
      return <label className='error-field-message-style'>Something went wrong, please try again.</label>
    }
    return <Loading />
  }

  const inChattingView = () => {
    return <PerfectScrollbar className='chat-container-padding in-chatting-container'>
      <label className='in-chatting-time'>{currentQuestion?.time}</label>
      <label className='in-chatting-question'>{currentQuestion?.question}</label>
      {
        inChattingBody()
      }
    </PerfectScrollbar>
  }

  const questionButton = (item) => {
    return (
      <button
        key={`questionButton:${item.question}`}
        className={'btn-back-button-common btn-download btn btn-primary new-chat-question-button'}
        onClick={() => startAskQuestion(item)}
      >
        {item.question}
      </button>
    )
  }

  const newChatView = () => {
    return <div className='chat-container-padding'>
      <label className='create-section-title'>How can I help you?</label>
      {
        chatQuestions.map(item => questionButton(item))
      }
    </div>
  }

  const chattingHistory = () => {
    return <div>
      in chatting history
    </div>
  }

  return (
    <>
      <button
        className="system-task-area"
        ref={popRef}
        onClick={() => {
          setShowAIChat(true)
          setIsInNewChat(true)
        }}
      >
        <Image src={askAI} className="ask-ai-header-button" />
      </button>
      <Overlay
        target={popRef.current}
        show={showAIChat}
        placement="bottom"
        rootClose
        onHide={closeAskAIPop}
      >
        {(props) => (
          <div
            {...props}
            className="overlay-trigger ask-ai-overlay-trigger"
            style={{
              padding: '2px 10px',
              color: 'white',
              borderRadius: 3,
              ...props.style,
              zIndex: 3,
              height: 'calc(100vh - 65px)',
              marginLeft: "-170px"
            }}
          >
            <Popover
              id={`ask_ai_popover`}
            >
              <Popover.Title>
                <div className="system-task-header ask-ai-system-header">
                  <label className="system-task center-system-task-title">
                    {"Ask AI"}
                  </label>
                  <div className='ask-ai-overlay-trigger-buttons'>
                    {/* <button
                      className="custom-image-button margin-left-10-percent"
                      onClick={showQuestionHistory}
                    >
                      <Image src={aiHistory} className="system-task-close" />
                    </button> */}
                    {
                      !isNewChat ? <button
                        className="custom-image-button margin-left-10-percent"
                        onClick={startNewChat}
                      >
                        <Image src={aiNewChat} className="system-task-close" />
                      </button> : null
                    }

                    <button
                      className="custom-image-button margin-left-10-percent"
                      onClick={closeAskAIPop}
                    >
                      <Image src={closeIcon} className="system-task-close" />
                    </button>
                  </div>
                </div>
              </Popover.Title>
              <Popover.Content style={{ height: "100%", overflowY: "hidden" }}>
                <div className='ask-ai-chat-body'>
                  {
                    isNewChat ? newChatView() : null
                  }
                  {
                    inChatting ? inChattingView() : null
                  }
                  {
                    inChattingHistory ? inChattingHistory() : null
                  }
                </div>
              </Popover.Content>
            </Popover>
          </div>
        )}
      </Overlay>
    </>)
}

export default connect(mapPropsToState)(AskAI);
